import React from 'react'
import { showDate } from 'utilities/form'
import { getLimit, getPagination } from 'utilities/pagination'
import { request } from 'utilities/request'
import { Link } from 'components/core'

export const columns = (message) => [
  {
    id: 'ticketId',
    label: `field.ticketId`,
    render: ({ row: { ticketType, ticketId } }) => {
      const type = getTicketType(ticketType)
      return (
        <Link
          variant="primaryLink"
          href={`${process.env.REACT_APP_REPAIR_URL}/${type}/${ticketId}/view`}
          target="_blank"
        >
          {ticketId}
        </Link>
      )
    },
  },
  {
    id: 'transDate',
    label: `inventory.field.transDate`,
    noWrap: true,
    render: ({ row }) => showDate(row.transDate),
  },
  {
    id: 'ticketType',
    label: `inventory.field.ticketType`,
    render: ({ row }) => message({ id: `ticketType.${row.ticketType}` }),
  },
  {
    id: 'locationName',
    label: `inventory.field.location`,
    render: ({ row }) => row.locationName,
  },
  {
    id: 'quantity',
    label: 'inventory.field.quantity',
    align: 'right',
    render: ({ row: { ticketType, quantity } }) => {
      if (['PART_CHECKIN', 'PART_SELL'].includes(ticketType)) {
        return quantity * -1
      }
      return quantity
    },
  },
]

function getTicketType(ticketType) {
  switch (ticketType) {
    case 'PART_BUY':
      return 'buy'
    case 'PART_CHECKOUT':
      return 'checkout'
    case 'PART_CHECKIN':
      return 'checkin'
    case 'PART_SELL':
      return 'sell'
    case 'PART_ADJUST':
      return 'adjust'
    default:
      return ticketType
  }
}

export const handlers = ({ setState, session, app, value, setPagination }) => ({
  handleLoad: async ({ pagination = {} } = {}) => {
    if (!value.productVariantId) return

    const resp = await getData({ session, app, value, pagination })
    setState(resp.data)
    setPagination(resp.pagination)
  },
})

async function getData({ session, app, value, pagination }) {
  const variables = { input: getDataInput({ pagination, value }) }
  const query = `
    query($input: InventoryQueryInput!) {
      inventoryLinkCount(input: $input)
      inventoryLinks(input: $input) {
        ticketId
        ticketType
        transDate
        locationName
        quantity
      }
    }
  `
  const [ok, data] = await request({ query, variables }, { session, app })
  if (!ok) return []

  const { page, countPerPage } = pagination
  return {
    data: data.inventoryLinks,
    pagination: getPagination(page, countPerPage, data.inventoryLinkCount),
  }
}

function getDataInput({ pagination, value }) {
  const input = {
    productVariantId: value.productVariantId,
    ticketType: value.ticketType,
    orderBy: [{ key: 'createdAt', sort: 'DESC' }],
  }
  if (value.transDate) input.transDate = value.transDate
  if (value.locationType) input.locationType = value.locationType
  if (pagination) input.limit = getLimit(pagination)
  return input
}
